import { render, staticRenderFns } from "./fixed.vue?vue&type=template&id=affbd9ba&scoped=true&"
import script from "./fixed.vue?vue&type=script&lang=js&"
export * from "./fixed.vue?vue&type=script&lang=js&"
import style0 from "./fixed.vue?vue&type=style&index=0&id=affbd9ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affbd9ba",
  null
  
)

export default component.exports